export const ADMIN_USERS_ROUTE = '/admin/users';

export const ADMIN_CHANGE_LOG_ROUTE = '/admin/change-log';
